import Workspace from 'shared/typings/workspaces/Workspace'

import { GlobalStore as store } from '@driftt/traffic-control'

export const getRoot = (state: any): Record<string, Workspace> => state.workspaces.workspace
export const getHasWorkspaces = (): boolean => Object.keys(getRoot(store.getState())).length > 1 // everybody has a default
export const getWorkspace = (id: string): Workspace | undefined => getRoot(store.getState())[id]
